import {
  CarrierRole,
  CarrierType,
  LogisticsKRLoadingWarehouse,
  LogisticsKRUnloadingWarehouse,
  LogisticStatuses,
} from 'views/pages/LogisticsKR/types'
import { LegalType, Region } from '../collection/types'
import { Team } from '../teams/types'
import { Coordinator, Profile } from '../user/types'
import { DispatchingStatuses } from 'views/pages/Dispatching/types'
import { RespFile } from '../types'

export type ProductLogistic = {
  id: string
  name: string
}

type Company = {
  id: string
  name: string
}

export type Assignee = {
  id: string
  phone: string
  short_name: string
}

interface AssigneeKR extends Assignee {
  full_name: string
  coordinator_type: string
}

export type LogisticRequest = {
  id: string
  deal_id: string
  created: string
  quantity: number
  distance: number
  customer: Customer
  source: string
  is_closed: boolean
  loading_company: Company
  unloading_company: Company
  price_logistics: number
  logistics_status: LogisticStatuses
  product: ProductLogistic
  loading_warehouse: LogisticsKRLoadingWarehouse
  unloading_warehouse: LogisticsKRUnloadingWarehouse
  trip_remained_quantity: number
  executors: AssigneeKR[]
  assignee?: AssigneeKR
  assigned_team?: Team
  cars_needed_count: number
  new_trip_offers_count: number
  trips_on_approval_count: number
  trips_count: number
  trips_loaded_quantity: number
  trips_unloaded_quantity: number
  deal_dispatching_status: DispatchingStatuses
  start_date: string
  close_date: string
}

export enum DealType {
  direct = 'direct',
  agent = 'agent',
  forwarding_company = 'forwarding_company',
}

export type BaseCompany = {
  id: string
  inn: string
  name: string
  phone: string
  contact_name?: string
  working_regions?: Region[]
  favorite_regions?: Region[]
}

export type Customer = BaseCompany
export type Carrier = BaseCompany & {
  is_in_charter: boolean
  favorite_regions: Region[]
  carrier_type: CarrierType
  has_vat: boolean
  carrier_role: CarrierRole[]
}

export type DetailedCarrier = Carrier & {
  verified_by_security_at?: string
  verified_by_security?: Coordinator
  verified_as_agent_by_security_at?: string
  responsible_logistician?: Coordinator
  legal_form?: {
    id: string
    short: string
  }
  legal_type: LegalType
}

export interface Employee {
  id: string
  phone: string
  email: string
  is_active: boolean
  profile: Profile | null
}

export enum OrdersCondition {
  active = 'active',
  archived = 'archived',
}

export enum StatusOrder {
  unpaid = 'unpaid',
  paid = 'paid',
}

export type PaymentOrder = {
  carrier: Carrier
  deal_id: string
  files: RespFile[]
  id: string
  is_archived: boolean
  payment_order_number: string
  status: StatusOrder
  status_changed_date: string
  trip_id: string
  request_id: string
}
